module.exports = {
    "Empty": `\xdcres`
};


//# sourceMappingURL=hu-HU.main.js.map
